import { createSelector } from "reselect";

const selectGeofenceState = (state) => state.geofences;

export const selectGeofences = createSelector(
  [selectGeofenceState],
  (geofences) => geofences.geofences
);

export const selectIsGeofencesLoaded = createSelector(
  [selectGeofences],
  (geofences) => geofences && geofences.length >= 0
);
